import axios from "axios";
import { toast } from "react-toastify";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  POWER_BANK_ACTIVE_LOADING,
  POWER_BANK_ACTIVE_ERROR,
  POWER_BANK_ACTIVE_FILTERS,
  POWER_BANK_ACTIVE_LIST,
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../../common/requests";

const chargerUrl = `${settings.chargerUrl}api/`;
const ENDPOINT = "admin/rent/active";

export const setLoading = (status) => ({
  type: POWER_BANK_ACTIVE_LOADING,
  payload: status
});

export const search = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, chargerUrl)
    .then(response => {
      dispatch({
        type: POWER_BANK_ACTIVE_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, POWER_BANK_ACTIVE_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters(ENDPOINT, chargerUrl)
    .then((response) => {
      dispatch({
        type: POWER_BANK_ACTIVE_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, POWER_BANK_ACTIVE_ERROR));
    });
};

export const finishRent = (stationQr, rentId, callback) => dispatch => {
  axios.post(`${chargerUrl}${ENDPOINT}/finish`, {
    rentId,
    stationQr,
  })
    .then(() => {
      toast("Rent finished successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, POWER_BANK_ACTIVE_ERROR));
    })
    .finally(callback);
};



// WEBPACK FOOTER //
// ./src/actions/chargers/activeRent/actions.js